import { render, staticRenderFns } from "./nav2.vue?vue&type=template&id=73e3ca07&scoped=true&"
import script from "./nav2.vue?vue&type=script&lang=js&"
export * from "./nav2.vue?vue&type=script&lang=js&"
import style0 from "./nav2.vue?vue&type=style&index=0&id=73e3ca07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e3ca07",
  null
  
)

export default component.exports